import React from 'react';

/**
 * SystemArchitecture Component - Minimal Blueprint
 * 
 * Simplified 5-node architecture diagram.
 * CLIENT → API → ENGINE → DATA → ANALYTICS
 * Thin strokes, no clutter, premium feel.
 */

export function SystemArchitecture() {
  return (
    <div className="relative w-full" style={{ minHeight: '340px' }}>
      <svg 
        viewBox="0 0 360 240" 
        className="w-full h-full"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <pattern id="heroGrid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255, 255, 255, 0.02)" strokeWidth="0.5"/>
          </pattern>
        </defs>

        {/* Background */}
        <rect width="360" height="240" fill="#151C26" rx="8" />
        <rect width="360" height="240" fill="url(#heroGrid)" rx="8" />
        
        {/* Border */}
        <rect width="360" height="240" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1" rx="8" />

        {/* Title */}
        <text x="20" y="28" fill="rgba(28, 124, 125, 0.8)" fontSize="9" fontFamily="'JetBrains Mono', monospace" fontWeight="500" letterSpacing="0.1em">
          SYSTEM ARCHITECTURE
        </text>
        <text x="320" y="28" textAnchor="end" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="'JetBrains Mono', monospace">
          v3.2
        </text>

        {/* Connection lines - 1px stroke */}
        <g stroke="rgba(20, 184, 166, 0.25)" strokeWidth="1">
          {/* CLIENT to API */}
          <path d="M 65 80 L 65 110 L 100 110" fill="none" />
          
          {/* API to ENGINE */}
          <path d="M 150 110 L 180 110" fill="none" />
          
          {/* ENGINE to DATA */}
          <path d="M 180 135 L 180 170 L 130 170" fill="none" />
          
          {/* ENGINE to ANALYTICS */}
          <path d="M 230 110 L 280 110" fill="none" />
          
          {/* DATA to ANALYTICS */}
          <path d="M 130 170 L 280 170 L 280 135" fill="none" stroke="rgba(28, 124, 125, 0.12)" strokeDasharray="4,4" />
        </g>

        {/* Nodes - Clean rectangles */}
        <g style={{ fontFamily: "'JetBrains Mono', monospace" }}>
          
          {/* CLIENT */}
          <rect x="40" y="55" width="50" height="28" rx="3" 
                fill="#1B2430" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <text x="65" y="73" textAnchor="middle" fill="rgba(255,255,255,0.78)" fontSize="9">CLIENT</text>

          {/* API */}
          <rect x="100" y="95" width="50" height="30" rx="3" 
                fill="#1B2430" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <text x="125" y="114" textAnchor="middle" fill="rgba(255,255,255,0.78)" fontSize="9">API</text>

          {/* ENGINE - Core, highlighted */}
          <rect x="180" y="90" width="70" height="45" rx="4" 
                fill="rgba(20, 184, 166, 0.15)" stroke="rgba(20, 184, 166, 0.4)" strokeWidth="1" />
          <text x="215" y="110" textAnchor="middle" fill="#14B8A6" fontSize="11" fontWeight="500">ENGINE</text>
          <text x="215" y="124" textAnchor="middle" fill="rgba(20, 184, 166, 0.6)" fontSize="7">core</text>

          {/* DATA */}
          <rect x="80" y="155" width="50" height="30" rx="3" 
                fill="#1B2430" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <text x="105" y="174" textAnchor="middle" fill="rgba(255,255,255,0.78)" fontSize="9">DATA</text>

          {/* ANALYTICS */}
          <rect x="280" y="95" width="60" height="45" rx="3" 
                fill="#1B2430" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <text x="310" y="114" textAnchor="middle" fill="rgba(255,255,255,0.78)" fontSize="9">ANALYTICS</text>
          <text x="310" y="128" textAnchor="middle" fill="rgba(255,255,255,0.42)" fontSize="7">metrics</text>

        </g>

        {/* Metrics strip - bottom */}
        <g style={{ fontFamily: "'JetBrains Mono', monospace" }}>
          <line x1="20" y1="205" x2="340" y2="205" stroke="rgba(255,255,255,0.04)" strokeWidth="1" />
          
          <text x="70" y="222" textAnchor="middle" fill="rgba(255,255,255,0.38)" fontSize="7">Latency</text>
          <text x="70" y="233" textAnchor="middle" fill="rgba(20, 184, 166, 0.8)" fontSize="9">&lt;50ms</text>
          
          <text x="150" y="222" textAnchor="middle" fill="rgba(255,255,255,0.42)" fontSize="7">Throughput</text>
          <text x="150" y="233" textAnchor="middle" fill="rgba(20, 184, 166, 0.8)" fontSize="9">10K/s</text>
          
          <text x="230" y="222" textAnchor="middle" fill="rgba(255,255,255,0.42)" fontSize="7">Uptime</text>
          <text x="230" y="233" textAnchor="middle" fill="rgba(20, 184, 166, 0.8)" fontSize="9">99.9%</text>
          
          <text x="310" y="222" textAnchor="middle" fill="rgba(255,255,255,0.42)" fontSize="7">Accuracy</text>
          <text x="310" y="233" textAnchor="middle" fill="rgba(20, 184, 166, 0.8)" fontSize="9">99.2%</text>
        </g>

        {/* Status indicator */}
        <circle cx="340" cy="24" r="3" fill="rgba(61, 158, 66, 0.6)" />
      </svg>
    </div>
  );
}

export default SystemArchitecture;
